import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import Modal from 'react-native-modal';
import CloseSVG from '~/assets/svgs/close.svg';

interface AttemptsErrorModalProps {
  visible: boolean;
  onDismiss: () => void;
}

const AttemptsErrorModal: React.FC<AttemptsErrorModalProps> = ({
  visible,
  onDismiss,
}) => {
  return (
    <Modal
      isVisible={visible}
      className="justify-center items-center"
      onBackdropPress={onDismiss}
      onBackButtonPress={onDismiss}
      onSwipeComplete={onDismiss}
      swipeDirection={['down']}
      propagateSwipe
    >
      <View className="bg-light-100 p-8 w-[60%]">
        <TouchableOpacity
          className="absolute right-4 top-4"
          onPress={onDismiss}
        >
          <CloseSVG height={24} width={24} />
        </TouchableOpacity>
        <Text className="text-2xl text-dark-500">
          Ops, tivemos um problema :(
        </Text>
        <Text className="text-base mt-4">
          Estamos com dificuldade para enviar o código nesse momento. Por favor
          entre em contato através da nossa central de atendimento.
        </Text>
      </View>
    </Modal>
  );
};

export default AttemptsErrorModal;
